import {
	TVatReimbursementItem,
	VatReimbursementStatus,
} from 'redux/reducers/vatReimbursement/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { TSalesProcessingRow } from '../../redux/reducers/salesProcessing/types';

export const vatReimbursementStructure: TTableStructure<keyof TVatReimbursementItem>[] = [
	{
		name: 'id',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		colSpan: 1,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'EM Status',
		selector: 'emStatus',
		noName: true,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ICON,
		icons: [
			{
				value: true,
				icon: EIconButtons.CHECK_CIRCLE,
				color: 'primary',
			},
			{
				value: false,
				icon: EIconButtons.BLOCK,
				color: 'error',
			},
		],
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		colSpan: 1,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Full Name',
		selector: 'fullName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.EM,
		value: (item: TVatReimbursementItem) => {
			return { id: item.emId, name: item.fullName };
		},
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'countryCode',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'IOSS Number',
		selector: 'iossNumber',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Invoice Number',
		selector: 'invoiceNumber',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Invoice Date',
		selector: 'invoiceDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country Name',
		selector: 'countryName',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reporting Period',
		selector: 'reportingPeriod',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE_MONTH,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'IOSS reported at',
		selector: 'fiscalReportFilingDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Amount',
		selector: 'reimbursementAmount',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Status',
		selector: 'paymentStatus',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[VatReimbursementStatus.PAID, 'paid'],
			[VatReimbursementStatus.PENDING, 'pending'],
			[VatReimbursementStatus.NO_INVOICE, 'no invoice'],
			[VatReimbursementStatus.PARTIALLY_PAID, 'partially paid'],
		],
		colors: [
			[VatReimbursementStatus.PAID, 'success.light'],
			[VatReimbursementStatus.PENDING, 'warning.light'],
			[VatReimbursementStatus.NO_INVOICE, 'error.light'],
			[VatReimbursementStatus.PARTIALLY_PAID, 'warning.light'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Money received',
		selector: 'moneyReceived',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Money received at',
		selector: 'receivedAt',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['empty', 'Empty date'],
			['notEmpty', 'Not empty date'],
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Included into Invoice',
		selector: 'invoicedBy',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['empty', 'Empty'],
			['notEmpty', 'Not empty'],
		],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Edited by',
		selector: 'editedBy',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [{ name: 'Add Comment', icon: EIconButtons.COMMENT }, { name: 'Receive', icon: EIconButtons.RECEIPT_LONG }],
	},
];
